/*eslint no-unused-vars: ["error", { "vars": "local" }]*/

import './main.scss'

import 'blissfuljs/bliss.shy.js'
import 'blissfuljs/bliss._.js'

const {$, $$} = window // eslint-disable-line

import * as Sentry from '@sentry/browser'

import {Gallery} from 'bliss-gallery'
import {LiveFilter} from './js/livefilter'
import {Navigation} from './js/navigation'
import {EventFilter} from './js/eventFilter'
import {ToggleElements} from './js/toggleElements'
import {ToggleSingleElements} from './js/toggleSingleMenu'
import {ArticleRating} from './js/articleRating'
import {Shop} from './js/shop'
import DonationRangeSlider from './js/donationRangeSlider'
import LoginRegisterHandler from './js/LoginRegisterHandler'
import setupPushNotificationBanner from './js/pluginPushNotification'
// import {SwipeDetector} from 'swipedetector'
// import { LoginTabs } from './js/loginTabs';
//
import {initMembershipFees, initPayment} from './js/signup'
import {tsriDropdownSetup} from './js/tsriDropdown'

import './js/shariff.complete.js'

$.ready().then(function() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/navigatorPush.service.js?version=1.0.0')
      .catch(Sentry.captureException)
  }
  // Crowdfunding – no goodie :(

  // Disabled by Nico (29.07.2019) because it's not used at the moment
  /*const crowdfundingGoodie = $('#crowdfunding-goodie input')
  const crowdfundingFormHidden = $('#crowdfunding-hidden')

  const crowdfundingAmount = $('.crowdfunding-form #id_amount')

  if (crowdfundingGoodie) {
    crowdfundingAmount.setAttribute('step', '10')

    let deactivateHiddenForm = crowdfundingFormHidden.querySelectorAll(
      'input, textarea'
    )
    deactivateHiddenForm.forEach(function(e) {
      e.disabled = false
    })

    crowdfundingGoodie.addEventListener('change', function() {
      if (crowdfundingGoodie.checked) {
        crowdfundingFormHidden.classList.add('is-collapsed')
        deactivateHiddenForm.forEach(function(e) {
          e.disabled = true
        })
      } else {
        crowdfundingFormHidden.classList.remove('is-collapsed')
        deactivateHiddenForm.forEach(function(e) {
          e.disabled = false
        })
      }
    })
    if (crowdfundingGoodie.checked) {
      crowdfundingFormHidden.classList.add('is-collapsed')
      deactivateHiddenForm.forEach(function(e) {
        e.disabled = true
      })
    } else {
      crowdfundingFormHidden.classList.remove('is-collapsed')
      deactivateHiddenForm.forEach(function(e) {
        e.disabled = false
      })
    }
  }*/

  $.fetch(`/api/sentry_dsn`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(res => {
    try {
      const response = JSON.parse(res.response)
      Sentry.init({
        dsn: response.dsn,
        environment: response.environment,
        release: response.release,
        whitelistUrls: [/https?:\/\/((www)\.)?tsri\.(ch|dev)/],
      })
    } catch (err) {
      console.log('err', err) // eslint-disable-line
      // TODO: what to do with err
    }
  })

  // Member Signup Banner Setup
  const banner = $('#member-signup-banner')
  if (banner) {
    if (sessionStorage.getItem('member-signup-small') === null) {
      $('.member-signup-banner__text', banner).classList.add('animation')
      $('.member-signup-banner__close-icon', banner).classList.add('animation')
      banner.classList.remove('small')
    }
    $('.member-signup-banner__close-icon', banner)._.bind('click', event => {
      event.preventDefault()
      sessionStorage.setItem('member-signup-small', 'true')
      banner.classList.add('small')
    })
  }

  tsriDropdownSetup()

  $$('.gallery').forEach(el => {
    new Gallery(el, {autoPlay: true})
    let current =
      ($('.gallery__slider').offsetWidth * null) / 3 -
      0.5 * $('.gallery__slider').offsetWidth * (1 - Math.floor(1.2) / 1.2)
    let offset =
      (($('.gallery__slider').offsetWidth * null) / 1.2 - current) * 3
    $('.gallery__slider').style.transform =
      'translate3d(-' + offset + 'px, 0px, 0px)'
  })

  $$('[data-livefilter]').forEach(item => new LiveFilter(item))
  $$('.article__rating form').forEach(el => {
    new ArticleRating(el.closest('.article__rating'))
  }) // FIXME ugly.

  new Navigation()
  let eventFilter = $('.event-filter')
  if (eventFilter) {
    new EventFilter(eventFilter)
  }

  let shopBody = $('.shop')
  if (shopBody) {
    new Shop()
  }

  new ToggleElements()
  new ToggleSingleElements()

  const loginRegisterEls = $$('[data-login-register]')
  loginRegisterEls.length && new LoginRegisterHandler(loginRegisterEls)

  $$('.membership-fees').forEach(el => initMembershipFees(el))
  //payment
  $$('.payment-and-donation__wrapper').forEach(() => initPayment())

  // new LoginTabs();

  function ajaxForm(id) {
    $.delegate(document.documentElement, 'submit', '#' + id, function(event) {
      event.preventDefault()

      let form = $('#' + id)
      let data = []
      for (let i = 0; i < form.elements.length; i++) {
        data.push(
          encodeURIComponent(form.elements[i].name) +
            '=' +
            encodeURIComponent(form.elements[i].value)
        )
      }
      $.fetch(form.action, {
        method: 'POST',
        data: data.join('&'),
      })
        .then(function(xhr) {
          let parentNode = form.parentNode
          form.outerHTML = xhr.responseText
          $$('script', parentNode).forEach(function(el) {
            // disqus complains about reload
            if (el.classList.contains('disqus-code')) {
              // eslint-disable-next-line no-undef
              DISQUS.reset({
                reload: true,
                config: function() {
                  this.page.identifier = window.disqus_vars.page_identifier
                  this.page.url = window.disqus_vars.page_url
                },
              })
            } else {
              eval(el.innerHTML)
            }
          })
        })
        .catch(function(/* error */) {
          // console.log(error, 'code: ' + error.status);
        })
    })
  }

  $$('.ajax-form').forEach(function(el) {
    ajaxForm(el.id)
  })

  // Automatically set donation amount when selecting a reward.
  $('.flock') &&
    $('.flock')._.delegate('change', 'input[name=reward]', function(event) {
      let amount = parseFloat(
        event.target.parentNode.innerText.replace(/[^.0-9]+/g, '')
      )
      if (!isNaN(amount)) {
        $('#id_amount').value = amount
      }
    })

  $$('form[target=_blank]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault()

      window.open('', 'form-target', 'width=600,height=600,resizable=yes')
      form.target = 'form-target'
      form.submit()
    })
  })

  // Ping ad impressions URL
  setTimeout(
    () =>
      $$('img[data-ping-url]').forEach(el => {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(el.dataset.pingUrl, 'beacon')
        } else {
          $.fetch(el.dataset.pingUrl, {method: 'POST'}).catch(() => {
            // Ignore failure
          })
        }
      }),
    3000
  )

  $$('[data-donation-range-slider]').forEach(el => {
    new DonationRangeSlider(el)
  })

  $$('[data-crowdfunding-range-slider]').forEach(el => {
    new DonationRangeSlider(el)
  })

  if (window.location.pathname == '/accounts/signup/details/') {
    document.body.classList.add('contact')

    if (document.body.children[1].classList.contains('msg')) {
      document.body.removeChild(document.body.children[1])
    }
  }

  /*$$('.profile-settings').forEach(el => {
    const amount = $('input[name="amount"]', el)
    $.delegate(el, 'change', 'input[name="periodicity"]', e => {
      if (e.target.value == 'monthly') {
        amount.value = Math.max(5, Math.floor(parseInt(amount.value, 10) / 12))
      } else if (e.target.value == 'quarterly'){
        amount.value = Math.max(15, Math.floor(parseInt(amount.value, 10) / ))
      } else {
        amount.value = Math.max(60, 12 * parseInt(amount.value, 10))
      }
    })
  })*/

  // Crowdsourcing – diffrent address

  const livingAddress = $('#living-address')
  const sourcingFormHidden = $('#sourcing-hidden')
  const sourcingFormTitle = $('#sourcing-form-title')
  if (livingAddress) {
    $('#id_living_city').setAttribute('value', 'Zürich')
    $('#id_living_city').setAttribute('readonly', true)
    $('#id_living_zip').setAttribute('pattern', '\\d{4}')
    $('#id_living_zip').setAttribute('placeholder', 'z.B 8005')
    $('#id_living_zip').setAttribute(
      'title',
      'Es muss sich um eine zürcher Postleitzahl handeln.'
    )
  }

  if (sourcingFormTitle) {
    let deactivateHiddenForm = sourcingFormHidden.querySelectorAll('input')
    deactivateHiddenForm.forEach(function(e) {
      e.disabled = true
    })

    if (livingAddress.checked) {
      sourcingFormHidden.classList.remove('is-collapsed')
      deactivateHiddenForm.forEach(function(e) {
        e.disabled = false
      })
    }

    livingAddress.addEventListener('change', function() {
      if (livingAddress.checked) {
        sourcingFormHidden.classList.remove('is-collapsed')
        let changeText = livingAddress.getAttribute('data-collapsed')
        deactivateHiddenForm.forEach(function(e) {
          e.disabled = false
        })
        livingAddress.innerHTML = changeText
      } else {
        deactivateHiddenForm.forEach(function(e) {
          e.disabled = true
        })
        sourcingFormHidden.classList.add('is-collapsed')
      }
    })
  }

  const amount = document.getElementById('id_amount')
  if(amount) {
    amount.addEventListener('change', function(event) {
      const want_membership = document.getElementById('id_want_membership')
      try {
        const value = parseInt(event.target.value)
        want_membership.disabled = value < 60
        if(value < 60) {
          want_membership.checked = false
        }
      } catch(error) {
        Sentry.captureException(error)
      }
    })
  }

  // Setup Push Notification Banner if available
  setupPushNotificationBanner()
})
